import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fd5b876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1 text-primary border border-primary px-3 py-1 rounded" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_10 = { class: "card-body pt-2" }
const _hoisted_11 = {
  key: 0,
  class: "card-body pt-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "ads-summary-cards" }
const _hoisted_20 = { class: "ads-summary-row" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"ads-summary-left\" data-v-1fd5b876><div class=\"ads-icon-box ads-icon-purple\" data-v-1fd5b876><img src=\"/media/icons/dash/reg.png\" alt=\"Regular Icon\" width=\"25\" height=\"25\" data-v-1fd5b876></div><div class=\"ads-summary-info\" data-v-1fd5b876><div class=\"ads-summary-title\" data-v-1fd5b876>Regular Ads<br data-v-1fd5b876>Count</div></div></div>", 1)
const _hoisted_22 = { class: "ads-summary-right" }
const _hoisted_23 = { class: "ads-summary-label" }
const _hoisted_24 = { class: "ads-summary-value" }
const _hoisted_25 = { class: "ads-summary-number" }
const _hoisted_26 = { class: "ads-summary-row" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"ads-summary-left\" data-v-1fd5b876><div class=\"ads-icon-box ads-icon-orange\" data-v-1fd5b876><img src=\"/media/icons/dash/specialads.png\" alt=\"specialads Icon\" width=\"25\" height=\"25\" data-v-1fd5b876></div><div class=\"ads-summary-info\" data-v-1fd5b876><div class=\"ads-summary-title\" data-v-1fd5b876>Special Ads<br data-v-1fd5b876>Count</div></div></div>", 1)
const _hoisted_28 = { class: "ads-summary-right" }
const _hoisted_29 = { class: "ads-summary-label" }
const _hoisted_30 = { class: "ads-summary-value" }
const _hoisted_31 = { class: "ads-summary-number" }
const _hoisted_32 = { class: "stats-scroll-row d-flex flex-row ps-4" }
const _hoisted_33 = { class: "flex-grow-1 w-100" }
const _hoisted_34 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_35 = { class: "fs-4 fw-bold text-dark mb-1" }
const _hoisted_36 = { class: "row p-1" }
const _hoisted_37 = { class: "col-12 title-border" }
const _hoisted_38 = { class: "text-muted fs-7 mb-1" }
const _hoisted_39 = { class: "fs-6 fw-bold text-dark" }
const _hoisted_40 = {
  key: 0,
  class: "text-success fs-7 fw-bold"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up ms-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.translate('adsSummary')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedPeriod === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'yesterday' }]),
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('yesterday')), 3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last7Days')), 3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last30Days')), 3)
            ]),
            _hoisted_9,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
              }, _toDisplayString(_ctx.translate('customRange')), 3)
            ])
          ])
        ]),
        _createVNode(_component_CustomDatePicker, {
          show: _ctx.showDatePicker,
          dateFrom: _ctx.customDateFrom,
          "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
          dateTo: _ctx.customDateTo,
          "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
          onApply: _ctx.applyCustomDates,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
        }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_16))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.translate('totalRegularsAdsCount')), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString((_ctx.regularAds.total ?? 0).toLocaleString()), 1),
                      (_ctx.regularAds.percentage !== 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "fs-7 fw-bold d-inline-flex align-items-center ms-2",
                            style: _normalizeStyle({ color: _ctx.textColor(_ctx.regularAds.percentage) })
                          }, _toDisplayString(_ctx.pct(_ctx.regularAds.percentage)) + "% " + _toDisplayString(_ctx.arrow(_ctx.regularAds.percentage)), 5))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.translate('totalSpecialAdsCount')), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString((_ctx.specialAds.total ?? 0).toLocaleString()), 1),
                      (_ctx.specialAds.percentage !== 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "fs-7 fw-bold d-inline-flex align-items-center ms-2",
                            style: _normalizeStyle({ color: _ctx.textColor(_ctx.specialAds.percentage) })
                          }, _toDisplayString(_ctx.pct(_ctx.specialAds.percentage)) + "% " + _toDisplayString(_ctx.arrow(_ctx.specialAds.percentage)), 5))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfData, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex flex-column align-items-start mb-7 me-4 info-content",
                    key: item.desc,
                    style: {"min-width":"200px"}
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, _toDisplayString(item.desc), 1),
                              _createElementVNode("div", _hoisted_39, _toDisplayString(item.count), 1)
                            ])
                          ])
                        ]),
                        (!_ctx.enableTrend)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createTextVNode(_toDisplayString(item.trend) + " ", 1),
                              _hoisted_41
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}